import { Link } from "react-router-dom";
import { ArrowLeft, HandHeart } from "@phosphor-icons/react";

export default function DonationCancel() {
  return (
    <div
      data-testid="donation-cancel-page"
      className="min-h-screen bg-[#FDFBF7] flex items-center justify-center px-6 py-20"
    >
      <div className="max-w-xl w-full text-center space-y-7">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-[#5A524A] hearth-link mb-2"
        >
          <ArrowLeft size={16} /> Back to Hearthside
        </Link>
        <h1 className="font-headline font-light text-4xl md:text-5xl text-[#1F1A17]">
          No worries — <span className="italic text-[#C25934]">the door's still open</span>.
        </h1>
        <p className="text-lg text-[#5A524A] leading-relaxed">
          You didn't complete the gift, and that's okay. There are many ways to support
          Hearthside — volunteer an evening, share our story, or simply tell a neighbor we're
          here.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            data-testid="cancel-home-button"
            className="btn-hearth inline-flex items-center gap-2 rounded-full bg-[#C25934] hover:bg-[#A04728] text-white px-7 py-3 font-semibold"
          >
            <HandHeart size={18} weight="duotone" /> Try again
          </Link>
        </div>
      </div>
    </div>
  );
}
